import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const aeroGridCss = ":host{display:grid;position:relative;grid-gap:var(--grid-gap);grid-auto-flow:dense;grid-template-columns:repeat(auto-fit, minmax(var(--grid-item-size), 1fr))}:host(.squares){grid-auto-rows:1fr}:host(.squares)::before{content:\"\";width:0;height:0;padding-bottom:100%;grid-row:1/1;grid-column:1/1}:host(.squares) ::slotted(*:first-child){grid-row:1/1;grid-column:1/1}@media screen and (min-width: 768px){:host(.variations) ::slotted(*:nth-child(12n-8)){grid-column:span 1;grid-row:span 2}:host(.variations) ::slotted(*:nth-child(16n-8)){grid-column:span 2;grid-row:span 2}}";

const AeroGrid$1 = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    /**
     * Sets the gaps (gutters) between grid rows and columns
     */
    this.gap = '1rem';
    /**
     * Sets the children cards image width and min-height
     */
    this.itemSize = '300px';
    /**
     * Activate/deactivate grid children cards size variation
     */
    this.variations = true;
    /**
     * Activate/deactivate grid children cards square (1:1) aspect ratio
     */
    this.squares = true;
    /**
     * Sets the children cards image hover effect. This can be one of the following:
     * fade-in, fade-out, swipe, slide, slide-over, zoom-in, zoom-out, shake,
     * trans, flip, flip-in, flip-out, bubble, bounce-in, bounce-out, flip-forward,
     * flip-backward, sense-3d
     */
    this.globalEffect = 'sense-3d';
    /**
     * Specifies children cards border radius
     */
    this.globalBorderRadius = '0';
  }
  newCardAddedHandler(event) {
    const card = event.detail;
    card.classList.add('on-grid');
    card.setAttribute('effect', this.globalEffect);
    card.setAttribute('border-radius', this.globalBorderRadius);
    if (this.squares) {
      card.classList.add('square');
    }
  }
  watchSquaresHandler(isSquaresAspectRatio) {
    isSquaresAspectRatio ? this.addChildrenClass('square') : this.removeChildrenClass('square');
  }
  watchGlobalEffect(newGlobalEffect) {
    this.setChildrenAttribute('effect', newGlobalEffect);
  }
  watchGlobalBorderRadius(newGlobalBorderRadius) {
    this.setChildrenAttribute('border-radius', newGlobalBorderRadius);
  }
  setChildrenAttribute(name, value) {
    const cards = this.el.querySelectorAll('aero-card');
    cards.forEach((effect) => effect.setAttribute(name, value));
  }
  addChildrenClass(className) {
    const cards = this.el.querySelectorAll('aero-card');
    cards.forEach((effect) => effect.classList.add(className));
  }
  removeChildrenClass(className) {
    const cards = this.el.querySelectorAll('aero-card');
    cards.forEach((effect) => effect.classList.remove(className));
  }
  componentWillRender() {
    this.variations ? this.el.classList.add('variations') : this.el.classList.remove('variations');
    this.squares ? this.el.classList.add('squares') : this.el.classList.remove('squares');
  }
  connectedCallback() {
    this.addChildrenClass('on-grid');
    this.setChildrenAttribute('effect', this.globalEffect);
    this.setChildrenAttribute('border-radius', this.globalBorderRadius);
    if (this.squares) {
      this.addChildrenClass('square');
    }
  }
  render() {
    return (h(Host, null, h("style", null, `
          :host {
            --grid-gap: ${this.gap};
            --grid-item-size: ${this.itemSize};
          }
        `), h("slot", null)));
  }
  get el() { return this; }
  static get watchers() { return {
    "squares": ["watchSquaresHandler"],
    "globalEffect": ["watchGlobalEffect"],
    "globalBorderRadius": ["watchGlobalBorderRadius"]
  }; }
  static get style() { return aeroGridCss; }
}, [1, "aero-grid", {
    "gap": [1],
    "itemSize": [1, "item-size"],
    "variations": [4],
    "squares": [4],
    "globalEffect": [1, "global-effect"],
    "globalBorderRadius": [1, "global-border-radius"]
  }, [[2, "newCardAdded", "newCardAddedHandler"]]]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["aero-grid"];
  components.forEach(tagName => { switch (tagName) {
    case "aero-grid":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, AeroGrid$1);
      }
      break;
  } });
}
defineCustomElement$1();

const AeroGrid = AeroGrid$1;
const defineCustomElement = defineCustomElement$1;

export { AeroGrid, defineCustomElement };
